import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "../helpers/DrawerActions";
import {formatPrice} from "../helpers";
import getCurrency from "helpers/currencyHelper";

const projectAccountCardFactorsColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        mainColumn: true,
    },
    {
        name: "عنوان",
        key: "title",
        filterParams: {
            column: "title",
            columnType: "string",
        },
        mainColumn: true,
        clickable: () => true,
        onClick: (dispatch: any, item: any) => {
            openFactorDrawer(dispatch, item);
        },
        disableSearch: true,
    },
    {
        name: "مشتری",
        key: "Person",
        searchKey: "nickName",
        getValue: (item: { Person: { nickName: any } }) => {
            return item.Person?.nickName ?? "-";
        },
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
        mainColumn: false,
        navigateKey: (item: { PersonId: any }) => item.PersonId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "مبلغ",
        key: "totalPrice",
        getValue: (item: { totalPrice: any; Currency: { en_title: any } }) =>
            `${formatPrice(item?.totalPrice || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
        // price: true,
        filterParams: {
            column: "price",
            columnType: "number",
        },
        disableSearch: true,
        searchType: "quantitative",
    },
    {
        name: "تاریخ ثبت",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        mainColumn: true,
        searchType: "date",
    },
    {
        name: "وضعیت",
        key: "status",
        size: "2",
        disableSearch: true,
        searchType: "status",
        mainColumn: true,
        dataKey: [
            {label: "دریافت شده", value: "دریافت شده", id: 1},
            {label: "تایید شده", value: "تایید شده", id: 2},
            {label: "پیش نویس", value: "پیش نویس", id: 3},
        ],
    },
];
const projectAccountCardTransactionsColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        mainColumn: true,
    },
    {
        name: "مبلغ",
        key: "amount",
        filterParams: {
            column: "amount",
            columnType: "number",
        },
        disableSearch: true,
        getValue: (item: { amount: any; Currency: { en_title: any } }) =>
            `${formatPrice(item?.amount || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
        searchType: "quantitative",
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        mainColumn: true,
        clickable: () => true,
        onClick: (dispatch: any, item: { id: any }) => {
            openTransactionDrawer(dispatch, {id: item.id});
        },
    },
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        mainColumn: true,
        searchType: "date",
    },
];
const projectAccountCardAccountingColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        mainColumn: true,
    },
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        mainColumn: true,
        showDatePicker: true,
        searchType: "date",
    },
    {
        name: "مبلغ",
        key: "amount",
        price: true,
        filterParams: {
            column: "amount",
            columnType: "number",
        },
        disableSearch: true,
        searchType: "quantitative",
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        mainColumn: true,
        clickable: () => true,
        onClick: (dispatch: any, item: { type: string; type_id: any }) => {
            if (item.type && item.type_id) {
                if (item.type === "factor") {
                    openFactorDrawer(dispatch, item);
                } else if (item.type === "transaction") {
                    openTransactionDrawer(dispatch, item);
                } else if (item.type === "transfer") {
                    openTransferDrawer(dispatch, item);
                } else if (item.type === "bill") {
                    openRemittanceDrawer(dispatch, item);
                }
            } else {
                openAccountingDrawer(dispatch, item);
            }
        },
    },
];
const projectAccountCardBillsColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        mainColumn: true,
    },
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        mainColumn: true,
        searchType: "date",
    },
    {
        name: "انبار",
        key: "Warehouse",
        getValue: (remittance: { Warehouse: { title: any } }) => remittance.Warehouse?.title,
        filterParams: {
            column: "name",
            columnType: "string",
        },
        mainColumn: false,
        searchType: "autocomplete",
        dataKey: {
            column: "inventories",
            key: "title",
        },
    },
    {
        name: "نوع",
        key: "factor_type",
        filterParams: {
            column: "type",
            columnType: "string",
        },
        disableSearch: true,
        getValue: (remittance: { type: any }) => {
            return remittance.type === "exit" ? "خروج" : "ورود"
            // switch (remittance.factor_type) {
            //     case "buy":
            //         return "خرید";
            //     case "buyReturn":
            //         return "برگشت از خرید";
            //     case "sale":
            //         return "فروش";
            //     case "saleReturn":
            //         return "برگشت از فروش";
            //     case "waste":
            //         return "ضایعات";
            // }
        },
        searchType: "status",
        dataKey: [
            {label: "فروش", value: "sale", id: 1},
            {label: "خرید", value: "buy", id: 2},
            {label: "برگشت از فروش", value: "saleReturn", id: 3},
            {label: "برگشت از خرید", value: "buyReturn", id: 4},
            {label: "ضایعات", value: "waste", id: 5},
        ],
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        mainColumn: true,
        clickable: () => true,
        onClick: (dispatch: any, item: any) => {
            openRemittanceDrawer(dispatch, item);
        },
    },
];

export const projectAccountCardIndexData = [
    {
        key: "projectAccountFactors",
        apiKey: "factors",
        pluralLabel: "فاکتور ها",
        title: "فاکتور ها",
        tableColumns: projectAccountCardFactorsColumns,
        disableSearch: true,
        actions: {
            // fetch: apiGetProductCard,
        },
    },
    {
        key: "projectAccountTransactions",
        apiKey: "transactions",
        pluralLabel: "تراکنش ها",
        title: "تراکنش ها",
        tableColumns: projectAccountCardTransactionsColumns,
        disableSearch: true,
        actions: {
            // fetch: apiGetProductCard,
        },
    },
    {
        key: "projectAccountAccountings",
        apiKey: "accountings",
        pluralLabel: "اسناد حسابداری",
        title: "اسناد حسابداری",
        tableColumns: projectAccountCardAccountingColumns,
        disableSearch: true,
        actions: {
            // fetch: apiGetProductCard,
        },
    },
    {
        key: "projectAccountBills",
        apiKey: "bills",
        pluralLabel: "حواله انبار",
        title: "حواله انبار",
        tableColumns: projectAccountCardBillsColumns,
        disableSearch: true,
        actions: {
            // fetch: apiGetProductCard,
        },
    },
];
